import { jsx } from "@emotion/react/jsx-runtime";
import { useState } from "react";
import { useUpdateEffect } from "usehooks-ts";
import useUniqueId from "./useUniqueId.mjs";
import InlineList from "./InlineList.mjs";
import ToggleButton from "./ToggleButton.mjs";
import normalizeOptions from "./form/src/normalizeOptions.mjs";
function toggleItem(array, item, force) {
  if (array.includes(item) && force !== true) {
    if (force !== true) {
      return array.filter(i => i !== item);
    }
  } else if (force !== false) {
    return [...array, item];
  }
  return array;
}
function ToggleButtonGroup(_ref) {
  let {
    type,
    id,
    multiple = false,
    name,
    options,
    value,
    defaultValue,
    onChange,
    buttonProps,
    ...restProps
  } = _ref;
  let isControlled = value !== void 0;
  useUpdateEffect(() => {
    console.warn(`ToggleButtonGroup changed from ${isControlled ? "uncontrolled" : "controlled"} to ${isControlled ? "controlled" : "uncontrolled"}`, value);
  }, [isControlled]);
  useUpdateEffect(() => {
    if (isControlled) {
      setInternalValue(value);
    }
  }, [isControlled, value]);
  let [internalValue, setInternalValue] = useState(isControlled ? value : defaultValue);
  let normalizedOptions = normalizeOptions(options);
  id = useUniqueId(id, "toggle-button-group");
  return /* @__PURE__ */jsx(InlineList, {
    role: "group",
    id,
    ...restProps,
    children: normalizedOptions.map((option, index) => {
      return /* @__PURE__ */jsx(ToggleButton, {
        name,
        id: `${id}-${index}`,
        type: type ?? (multiple ? "checkbox" : "radio"),
        checked: internalValue === void 0 ? internalValue : multiple ? internalValue.includes(option.value) : option.value === internalValue,
        onChange: event => {
          let newValue = multiple ? toggleItem(internalValue, option.value, event.target.checked) : event.target.checked ? option.value : null;
          if (!isControlled) {
            setInternalValue(newValue);
          }
          if (onChange) {
            onChange({
              target: {
                value: newValue,
                name
              },
              originalEvent: event
            }, newValue);
          }
        },
        buttonProps: {
          ...buttonProps
        },
        ...option
      }, option.value);
    })
  });
}
export { ToggleButtonGroup as default };